import Filters from 'components/pages/search/filters'
import { useAssetsSearch } from './use-assets-search'
import { FilesList } from 'components/elements/files/files-list'
import Button from 'components/core/button'
import { useFilesContext } from 'components/elements/files/files-context'
import Pagination from 'components/elements/pagination'
import { AssetableType } from 'lib/api/ticket-files/ticket-files'
import { SearchTab } from '../constants/search-tabs'

const AssetsSearch = ({ assetableType, assetableId }: { assetableType: AssetableType; assetableId: number }) => {
  const { assetsQuery, assetsCount, assets, table, pagination } = useAssetsSearch()
  const { bulkDuplicateTicketFiles } = useFilesContext()

  return (
    <>
      <Filters table={table} currentTab={SearchTab.ASSETS} />
      {!!assetsCount && <div className="tw-py-2 tw-text-neutral-800">{`${assetsCount} asset(s) found`}</div>}
      <FilesList files={assets} size="md" isLoading={assetsQuery.isFetching} loadingCount={8} />
      <Pagination
        pageCount={assetsCount / pagination.pageSize}
        onPageChange={({ selected }) => {
          table.setPageIndex(selected + 1)
        }}
        forcePage={pagination.pageIndex - 1}
      />
      <Button
        color="purple"
        className="tw-ml-auto tw-mt-4"
        onClick={() => bulkDuplicateTicketFiles([{ assetable_type: assetableType, assetable_id: assetableId }])}
      >
        Upload
      </Button>
    </>
  )
}

export default AssetsSearch
